import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './PropertyPanel.css';
import { IATextField } from './../../../textField/TextField';
import { IADropDown } from './../../../dropDown/DropDown';
import { IAButton } from '../../../button/Button';
// import { TargetingService } from '../../../../services/TargetingService';
import { TargetingAdminStore } from '../../stores/TargetingAdminStore';
// import ITargetingProperties from '../../../../interfaces/ITargetingProperties';
import { ITargetTerm } from '../../../../interfaces/ITargetTerm';
import { TargetingService } from '../../../../services/TargetingService';
import { LocalizationService } from './../../../../services/LocalizationService';
import { IAPanel } from '../../../panels/Panel';
import { IAPopup } from '../../../popup/Popup';
import { Helper } from '../../../../Helper';

export interface IPropertyPanelProps {
  targetingStore?: TargetingAdminStore;
  selectedProperty: any;
  open: boolean;
  termGroupOptions: IComboBoxOption[];

  close: (updated: boolean) => void;
}


export interface IComboBoxOption {
  key: string;
  value: string;
  disabled?: boolean;
}

export interface IPropertyPanelState {
  value: string;
  userPropertySelected: string;
  termGroupMappingSelected: string;
  termSetMappingSelected: string;
  userProfileProperties: IComboBoxOption[];
  termsOptions: IComboBoxOption[];
  selectTermSetEnabled: boolean;

  termGroupOptions: IComboBoxOption[];
  isSaving: boolean;

}

@inject('targetingStore')
@observer
export class PropertyPanel extends React.Component<IPropertyPanelProps, IPropertyPanelState> {

  private cancelPopupId;

  constructor(props: IPropertyPanelProps, state: IPropertyPanelState) {
    super(props, state);

    this.state = {
      value: this.props.selectedProperty ? this.props.selectedProperty.displayName : "",
      userPropertySelected: this.props.selectedProperty ? this.props.selectedProperty.userProfileName : " ",
      termGroupMappingSelected: this.props.selectedProperty ? this.props.selectedProperty.groupIdentity : " ",
      termSetMappingSelected: this.props.selectedProperty ? this.props.selectedProperty.identity : " ",
      userProfileProperties: [],
      termsOptions: [],
      selectTermSetEnabled: false,
      termGroupOptions: [],
      isSaving: false
    };
    if (this.props.targetingStore.language != undefined) {
      this.props.targetingStore.setLanguage(this.props.targetingStore.language);
    }
    this.cancelPopupId = Helper.getRandomStringKey();

  }

  componentWillReceiveProps(nextProps: IPropertyPanelProps) {
    let combos = this.getTermsGroup();
    let userProfileProperties: IComboBoxOption[] = []

    userProfileProperties.push({
      key: " ",
      value: " "
    });
    if (this.props.targetingStore.userPropertiesList) {
      userProfileProperties.push(...this.props.targetingStore.userPropertiesList.map((property) => {
        return {
          key: property,
          value: property
        };
      })
      );
      userProfileProperties.sort((a, b) => {
        if (a.value < b.value) {
          return -1;
        }
        if (a.value > b.value) {
          return 1;
        }
        return 0;
      });
    }

    this.setState({ termGroupOptions: combos, userProfileProperties, termGroupMappingSelected: nextProps.selectedProperty ? nextProps.selectedProperty.groupIdentity : " " }, () => {
      this.setState({
        value: nextProps.selectedProperty ? nextProps.selectedProperty.displayName : "",
        userPropertySelected: nextProps.selectedProperty ? nextProps.selectedProperty.userProfileName : " ",
        termSetMappingSelected: nextProps.selectedProperty ? nextProps.selectedProperty.identity : " ",
        // userProfileProperties,
        // termsOptions: [],
        // selectTermSetEnabled: false
      });
    });
  }

  private getTermsGroup() {
    var termsLocalStorage = localStorage.getItem("Terms");
    var oTerms: ITargetTerm[];
    if (termsLocalStorage) {
      oTerms = JSON.parse(termsLocalStorage);
    } else {
      oTerms = this.props.targetingStore.termsList;
    }

    var _termsGroup: any[] = [];
    _termsGroup.push({ value: " ", key: " " });

    if (oTerms && Array.isArray(oTerms)) {
      oTerms.forEach(term => {
        if (!_termsGroup.some(t => t.key === term.iaTargetingTermsGroupId)) {
          _termsGroup.push({ value: term.iaTargetingTermsGroup, key: term.iaTargetingTermsGroupId });
        }
      });

      _termsGroup = _termsGroup.sort((x, y) => {
        if (x.text > y.text)
          return 1;

        if (x.text < y.text)
          return -1;

        return 0;
      });
    }

    return _termsGroup;
  }

  private closeTab(updated: boolean) {
    this.setState({
      value: "",
      userPropertySelected: " ",
      termGroupMappingSelected: " ",
      termSetMappingSelected: " ",
    }, () => this.props.close(updated));
  }

  render() {
    let panel = (
      <div className={styles.IA_viewPanelContentWrapper}>
        <div style={{ marginTop: 20, marginBottom: 10, fontWeight: 700 }}>
          {new LocalizationService().strings.TargetingAdmin_PropertyPanelTitle}
        </div>

        <div>
          <IATextField
            label={new LocalizationService().strings.TargetingAdmin_PropertyPanelDisplayName}
            text={this.state.value}
            borderRadius={5}
            onChange={(text) => this.setState({ value: text })}
            style={{ width: 'auto', marginBottom: '10px' }}
          />

          <IADropDown
            label={new LocalizationService().strings.TargetingAdmin_PropertyPanelUserProperty}
            selectedOption={this.state.userPropertySelected}
            borderRadius={5}
            options={this.state.userProfileProperties}
            onChange={(selectedOption: string) => this.setState({ userPropertySelected: selectedOption })}
          />

          <IADropDown
            label={new LocalizationService().strings.TargetingAdmin_PropertyPanelTermGroupMapping}
            selectedOption={this.state.termGroupMappingSelected}
            borderRadius={5}
            options={this.state.termGroupOptions}
            onChange={(option) => {
              this.onGroupMappingChanged(option);
            }}
          />

          <IADropDown
            label={new LocalizationService().strings.TargetingAdmin_PropertyPanelTermSetMapping}
            selectedOption={this.state.termSetMappingSelected}
            borderRadius={5}
            options={this.state.termsOptions}
            onChange={(selectedOption: string) => this.setState({ termSetMappingSelected: selectedOption })}
          />
        </div>
        <div style={{ float: 'left', position: 'absolute', bottom: '0', marginBottom: '20px' }}>
          <div>
            <IAButton
              style={{ float: 'left' }}
              buttonColor={this.props.targetingStore.highlightColor}
              borderRadius={5}
              showSpinner={this.state.isSaving}
              disbaled={this.state.isSaving || this.state.value === "" || this.state.userPropertySelected === " " || this.state.termGroupMappingSelected === " " || this.state.termSetMappingSelected === " "}
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsSave}
              onClick={() => this.setState({ isSaving: true }, () => this.savePanel())}
            />
            <IAButton
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsCancel}
              buttonColor={"#999999"}
              borderRadius={5}
              disbaled={this.state.isSaving}
              style={{ marginLeft: "10px", float: 'right' }}
              onClick={() => {
                if ((!this.props.selectedProperty && this.state.value !== "" && this.state.userPropertySelected !== " " && this.state.termGroupMappingSelected !== " " && this.state.termSetMappingSelected !== " ") ||
                  (this.props.selectedProperty && (this.props.selectedProperty.displayName !== this.state.value || this.props.selectedProperty.userProfileName !== this.state.userPropertySelected ||
                    this.props.selectedProperty.groupIdentity !== this.state.termGroupMappingSelected || this.props.selectedProperty.identity !== this.state.termSetMappingSelected))) {
                  this.props.targetingStore.showCancelPropertyPopUp = true;
                } else {
                  this.closeTab(false);
                }
              }
              }
            />
          </div>
        </div>
      </div>);
    return (
      <div>
        <IAPanel
          showNavigationBar={true}
          itemId={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.id !== undefined ? this.props.targetingStore.userGroupToEdit.id : undefined}
          open={this.props.open}
          transition={this.props.targetingStore.userGroupToEdit != undefined ? "fade" : "slide"}
          width={550}
          isMobile={false}
          tenant={this.props.targetingStore.tenant}
          token={this.props.targetingStore.token}
          environment={this.props.targetingStore.environment}
          disableSaving={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title === undefined
            || this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title == ""
          }
          // Actions
          close={() => {
            if ((!this.props.selectedProperty && this.state.value !== "") ||
              (this.props.selectedProperty && (this.props.selectedProperty.displayName !== this.state.value || this.props.selectedProperty.userProfileName !== this.state.userPropertySelected ||
                this.props.selectedProperty.groupIdentity !== this.state.termGroupMappingSelected || this.props.selectedProperty.identity !== this.state.termSetMappingSelected))) {
              this.props.targetingStore.showCancelPropertyPopUp = true;
            } else {
              this.closeTab(false);
            }
          }}
        >{panel}</IAPanel>
        <div id={`cancelPopupId_${this.cancelPopupId}`}>
          {this.props.targetingStore.showCancelPropertyPopUp &&
            <IAPopup
              headline={new LocalizationService().strings.CancelPopup_Headline}
              content={
                <div>
                  <IAButton
                    label={new LocalizationService().strings.CancelPopup_Yes}
                    buttonColor={this.props.targetingStore.highlightColor}
                    borderRadius={5}
                    showSpinner={false}
                    onClick={() => {
                      this.props.targetingStore.showCancelPropertyPopUp = false;
                      this.closeTab(false);
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={new LocalizationService().strings.CancelPopup_No}
                    borderRadius={5}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.targetingStore.showCancelPropertyPopUp = false;
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.props.targetingStore.showCancelPropertyPopUp = false;
              }}
            />
          }
        </div>
      </div>
    );
  }

  private onGroupMappingChanged(option: string): void {

    this.setState({ termGroupMappingSelected: option })

    if (option !== " ") {
      this.getTerms(option);
      this.setState({ selectTermSetEnabled: true, termSetMappingSelected: " " });
    }
    else {
      // this.onPropertyMappingChanged(option, 0);
      this.setState({ selectTermSetEnabled: false, termSetMappingSelected: " " });
    }
  }

  private getTerms(groupId: string) {
    //console.log('Get terms ' + groupId);
    return new Promise<IComboBoxOption[]>((resolve) => {
      var allTerms = this.props.targetingStore.termsList;
      var _terms: IComboBoxOption[] = [];

      _terms.push({ value: " ", key: " " });
      allTerms.filter(t => t.iaTargetingTermsGroupId === groupId).forEach(x => {
        _terms.push({ value: x.title, key: x.iaTargetingTermsID });
      });

      _terms = _terms.sort((x, y) => {
        if (x.value > y.value)
          return 1;

        if (x.value < y.value)
          return -1;

        return 0;
      });

      this.setState({ termsOptions: _terms });
      resolve(_terms);
    });
  }

  private savePanel = (): void => {
    if (this.props.selectedProperty) {
      let updatedProperty = this.props.selectedProperty;
      updatedProperty.DisplayName = this.state.value;
      updatedProperty.UserProfileName = this.state.userPropertySelected;
      updatedProperty.GroupIdentity = this.state.termGroupMappingSelected;
      updatedProperty.Identity = this.state.termSetMappingSelected;
      TargetingService.updateProperty(updatedProperty, this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then(newProperty => {
        console.log(newProperty);
        this.setState({ isSaving: false }, () => this.closeTab(newProperty));
      });
    } else {
      TargetingService.createProperty(this.state.value, this.state.userPropertySelected, this.state.termSetMappingSelected, this.state.termGroupMappingSelected, this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token).then(newProperty => {
        console.log(newProperty);
        this.setState({ isSaving: false }, () => this.closeTab(newProperty));
      });
    }
  }
}
